import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberScopus } from "./routeType";

const { key, getPath } = getApi("members.scopus.get");

type IExtractedRouteType = IMemberScopus["scopusDataSingleRetrieve"];

export type IGetMemberScopus = IPickSingleQuery<IExtractedRouteType>;

const getMemberScopus: Fetcher<
  IGetMemberScopus["response"],
  IGetMemberScopus["variables"]
> = ({ memberId, ...params }) => {
  return axiosClient.get(getPath({ memberId }), { params });
};

export const useGetMemberScopus = createQuery({
  queryKey: [key],
  fetcher: getMemberScopus,
});
